import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/button';

type Props = {
  providerId: string;
  providerName: string;
  headless?: boolean;
  className?: string;
};

const LoginWithSaml: React.FC<Props> = ({
  providerId,
  providerName,
  headless,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      {!headless && (
        <>
          <h1 className="display-4 text-center mb-3">
            {t('signInSaml.title')}
          </h1>
          <p className="text-muted text-center mb-5">
            {t('signInSaml.subTitle', { provider: providerName })}
          </p>
        </>
      )}
      <Button
        className="w-100"
        label={t('signInSaml.button', { provider: providerName })}
        onClick={(e) => {
          e.preventDefault();
          window.location.href = `/_auth/saml?providerId=${encodeURIComponent(
            providerId,
          )}`;
        }}></Button>
    </div>
  );
};

export default LoginWithSaml;
